import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page } from "../components/Page";
import "../../i18n/i18n";

export const VehicleRestitutionPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Page
      title={t("driverPayment.restituteVehicle")}
      returnButton
      returnButtonAction={() => navigate(-1)}
    />
  );
};
